module.exports = __webpack_public_path__ + "static/media/5.15c8677.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/5.wav
// module id = rK+R
// module chunks = 0